import Api from '../api/Api';
import resolve from '../util/Configuracao';

class ElementoApi extends Api {
  async consultarElementosDaGuia (codLoteGuia, codGuia) {
    let elementos = [];
    try {
      var result = [];
      const responseProcedimento = await this.fetch(`/lote/${codLoteGuia}/guia/${codGuia}/procedimento`);
      const responseOutrasDespesas = await this.fetch(`/lote/${codLoteGuia}/guia/${codGuia}/outradespesa`);
      const responseOpme = await this.fetch(`/lote/${codLoteGuia}/guia/${codGuia}/opme`);
      result = responseProcedimento.data.concat(responseOutrasDespesas.data.concat(responseOpme.data));

      elementos = result;
      result.map(
        (el) => {
          el.valPctReducaoAcrescimoSolicitado = el.valPctReducaoAcrescimoSolicitado === null ? null : parseFloat(el.valPctReducaoAcrescimoSolicitado).toFixed(4) || null;
          el.valPctReducaoAcrescimoAutorizado = el.valPctReducaoAcrescimoAutorizado === null ? null : parseFloat(el.valPctReducaoAcrescimoAutorizado).toFixed(4);
          el.valTaxaVigente = el.valTaxaVigente === null ? null : parseFloat(el.valTaxaVigente).toFixed(4);
        });

      elementos = result.sort((a, b) => (a.codItem > b.codItem) ? 1 : -1);
      elementos = elementos.sort((a, b) => (a.codTipoItem > b.codTipoItem) ? 1 : -1);
      return elementos;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarElementosDaGuiaRecurso (codLoteGuia, codGuia) {
    let elementos = [];
    try {
      var result = [];
      const responseProcedimento = await this.fetch(`/lote/${codLoteGuia}/guia/${codGuia}/procedimento/recurso`);
      const responseOutrasDespesas = await this.fetch(`/lote/${codLoteGuia}/guia/${codGuia}/outradespesa/recurso`);
      const responseOpme = await this.fetch(`/lote/${codLoteGuia}/guia/${codGuia}/opme/recurso`);
      result = responseProcedimento.data.concat(responseOutrasDespesas.data.concat(responseOpme.data));

      elementos = result;
      result.map(
        (el) => {
          el.valPctReducaoAcrescimoSolicitado = el.valPctReducaoAcrescimoSolicitado === null ? null : parseFloat(el.valPctReducaoAcrescimoSolicitado).toFixed(4) || null;
          el.valPctReducaoAcrescimoAutorizado = el.valPctReducaoAcrescimoAutorizado === null ? null : parseFloat(el.valPctReducaoAcrescimoAutorizado).toFixed(4);
          el.valTaxaVigente = el.valTaxaVigente === null ? null : parseFloat(el.valTaxaVigente).toFixed(4);
        });

      elementos = result.sort((a, b) => (a.codItem > b.codItem) ? 1 : -1);
      elementos = elementos.sort((a, b) => (a.codTipoItem > b.codTipoItem) ? 1 : -1);
      return elementos;
    } catch (error) {
      console.error(error);
    }
  }

  async salvarAuditoriaElemento (codLoteGuia, elemento) {
    try {
      const result = await this.fetch(`/auditoria/elemento/salvar/${codLoteGuia}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error.response;
    }
  }
  async salvarAuditoriaElementoRecurso (codLoteGuia, elemento) {
    try {
      const result = await this.fetch(`/auditoria/elemento_recurso/salvar/${codLoteGuia}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error.response;
    }
  }
  async salvarAuditoriaElementoRecursoTrocaItem (codLoteGuia, elemento) {
    try {
      const result = await this.fetch(`/auditoria/elemento_recurso_troca_item/salvar/${codLoteGuia}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error.response;
    }
  }
  async getValVigente (codItemTabela, seqPrestador, dtaRealizacao) {
    try {
      const result = await this.fetch(`/auditoria/val_vigente/${codItemTabela}/${seqPrestador}/${dtaRealizacao}`, 'GET');
      return result;
    } catch (error) {
      return error;
    }
  }
  async aceitarAuditoriaElementoCNU (codLoteGuia, elemento) {
    try {
      const result = await this.fetch(`/auditoria/elemento/cnu/aceitar/${codLoteGuia}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async excluirElementoCNU (codLoteGuia, elemento) {
    try {
      const result = await this.fetch(`/auditoria/elemento/cnu/excluir/${codLoteGuia}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async rejeitarGlosaTST (codLoteGuia, elemento, txtJustificativa) {
    try {
      const result = await this.fetch(`/auditoria/elemento/cnu/rejeitar/${codLoteGuia}/${txtJustificativa}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }

  async desfazerAvaliacaoElementoCNU (codLoteGuia, elemento) {
    try {
      const result = await this.fetch(`/auditoria/elemento/cnu/desfazer/${codLoteGuia}`, 'POST', elemento, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      return error;
    }
  }
  async aceitarAditoriaElementosNaoAvaliados (codLoteGuia, codGuia) {
    try {
      const result = await this.fetch(`/auditoria/elementos/cnu/aceitar/${codLoteGuia}/${codGuia}`, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async excluirElementosNaoAvaliados (codLoteGuia, codGuia) {
    try {
      const result = await this.fetch(`/auditoria/elementos/cnu/excluir/${codLoteGuia}/${codGuia}`, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async desfazerAvaliacaoElementos (codLoteGuia, codGuia) {
    try {
      const result = await this.fetch(`/auditoria/elementos/cnu/desfazer/${codLoteGuia}/${codGuia}`, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }
  async ajustarGlosasElementosDaGuiaCnu (codLoteGuia, codGuia) {
    try {
      const result = await this.fetch(`/auditoria/elementos/cnu/ajustar_glosas/${codLoteGuia}/${codGuia}`, 'POST');
      return result;
    } catch (error) {
      return error;
    }
  }

  async anexarArquivo (idElemento, nomeArquivo, txtObjetoGed, codTipoItem) {
    try {
      const response = await this.fetch(`/auditoria/elemento/cnu/anexar_arquivo/${idElemento}/${nomeArquivo}/${txtObjetoGed}/${codTipoItem}`, 'PUT');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarArquivos (idElemento, codTipoItem) {
    try {
      const response = await this.fetch(`/auditoria/elemento/cnu/arquivos/${idElemento}/${codTipoItem}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async deletarArquivo (codArquivo) {
    try {
      const response = await this.fetch(`/auditoria/elemento/cnu/deletar_arquivo/${codArquivo}`, 'PUT');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async recuperarElementosTrocaPermissaoRecurso (codLoteGuia, codGuia) {
    let elementos = [];
    try {
      const urlElementosTrocaPermissaoRecurso = resolve('urlElementosTrocaPermissaoRecurso') + codLoteGuia + '/guia/' + codGuia + '/permissao_troca';
      const { data } = await this.fetch(urlElementosTrocaPermissaoRecurso);
      data.map(res => {
        const { id, codItem, desItem, desTabela, codItemTabela, codTipoItem, qtdSolicitada, qtdAutorizada, valUnitarioSolicitado, valUnitarioAutorizado, valTotalSolicitado, valTotalAutorizado, txtMotivoRecurso, indPodeTrocarItem, indDesistiuRecorrer, strDtaRealizacao } = res;
        elementos.push(Object.values({ id, strDtaRealizacao, desTabela, codItem, desItem, codItemTabela, codTipoItem, qtdSolicitada, qtdAutorizada, valUnitarioSolicitado, valUnitarioAutorizado, valTotalSolicitado, valTotalAutorizado, txtMotivoRecurso, indPodeTrocarItem, indDesistiuRecorrer }));
      });
      return elementos;
     } catch (error) {
      console.error(error);
    }
  }
  
  async alterarPermissaoTrocaItem (codLoteGuia, codGuia, id) {
    try {
      const urlAlterarTrocaPermissaoRecurso = resolve('urlAlterarTrocaPermissaoRecurso') + codLoteGuia + '/guia/' + codGuia + '/alterar_permissao_troca/' + id;
      await this.fetch(urlAlterarTrocaPermissaoRecurso, 'PUT');
    } catch (error) {
      console.error(error);
    }
  }

}

export default ElementoApi;
